import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { NoConnectionNotification } from '../components/notifications/no-connection/NoConnectionNotification';
import { JointEntryPoint } from '../components/early-settlement/joint-entry-point';
import { useAnalyticsPageViewTracker } from '@cp-shared-19/frontend-ui';

interface RouteParams {
    contractId: string;
}

export const EarlySettlementPage: React.FC = () => {
    const { contractId: encryptedContractId } = useParams<RouteParams>();
    useAnalyticsPageViewTracker('earlySettlement', !!encryptedContractId);

    if (!encryptedContractId) return <NoConnectionNotification />;

    return (
        <ContentSection pageWrapSize="medium">
            <JointEntryPoint encryptedContractId={encryptedContractId} />
        </ContentSection>
    );
};
